import { Link } from "react-router-dom";
import { Cross } from "lucide-react";

export const LandingFooter = () => (
  <footer className="border-t border-gray-100 bg-white" data-testid="landing-footer">
    <div className="max-w-6xl mx-auto px-6 py-10 grid gap-8 md:grid-cols-3 items-start">
      <div>
        <Link to="/" data-testid="footer-home" className="flex items-center gap-2.5">
          <div className="h-8 w-8 rounded-lg bg-emerald-600 text-white flex items-center justify-center">
            <Cross className="h-4 w-4" strokeWidth={2.5} />
          </div>
          <span className="font-head text-base font-extrabold tracking-tight">FarmaPresenze</span>
        </Link>
        <p className="mt-3 text-sm text-gray-600">Progettato per Farmacie e Parafarmacie.</p>
        <p className="mt-1 text-xs text-gray-500">Rilevazione presenze via WiFi, senza hardware.</p>
      </div>
      <nav className="text-sm text-gray-600 grid grid-cols-2 gap-2 md:justify-self-center" aria-label="Note legali">
        <Link to="/privacy" data-testid="footer-privacy" className="hover:text-emerald-700">Privacy Policy</Link>
        <Link to="/cookie-policy" data-testid="footer-cookie" className="hover:text-emerald-700">Cookie Policy</Link>
        <Link to="/termini" data-testid="footer-terms" className="hover:text-emerald-700">Termini del Servizio</Link>
        <Link to="/privacy#statuto-lavoratori" data-testid="footer-statuto" className="hover:text-emerald-700">Statuto dei Lavoratori</Link>
        <Link to="/preventivo" data-testid="footer-contact" className="hover:text-emerald-700">Preventivo gruppi</Link>
      </nav>
      <div className="text-sm text-gray-600 md:text-right">
        <p className="font-semibold text-gray-800">farmapresenze.com</p>
        <p data-testid="footer-legal-note" className="mt-1 text-xs text-gray-500">Privacy e tutela dei lavoratori · GDPR · L. 300/1970</p>
      </div>
    </div>
    <div className="border-t border-gray-100">
      <p data-testid="footer-copyright" className="max-w-6xl mx-auto px-6 h-12 flex items-center text-xs text-gray-500">
        © 2026 FarmaPresenze · Tutti i diritti riservati.
      </p>
    </div>
  </footer>
);
